webpackJsonp([43052463878090],{

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.morseScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _morsePanel = __webpack_require__(394);
	
	var _morsePanel2 = _interopRequireDefault(_morsePanel);
	
	var _morse = __webpack_require__(893);
	
	var _morse2 = _interopRequireDefault(_morse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.morseScxml = _morse2.default;
	
	var MorseExample = function (_React$Component) {
	  _inherits(MorseExample, _React$Component);
	
	  function MorseExample(props) {
	    _classCallCheck(this, MorseExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.timeouts = {};
	    _this.state = {
	      transcript: '',
	      signals: []
	    };
	    return _this;
	  }
	
	  MorseExample.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _scxml2.default.documentStringToModel(null, _morse2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2),
	          customCancel: _this2.customCancel.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  MorseExample.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _this3 = this;
	
	    Object.keys(this.timeouts).forEach(function (sendid) {
	      return _this3.customCancel(sendid);
	    });
	  };
	
	  MorseExample.prototype.customSend = function customSend(event, options) {
	    var _this4 = this;
	
	    var send = function send() {
	      switch (event.name) {
	        case 'dot':
	          _this4.appendSignal('.');
	          break;
	        case 'dash':
	          _this4.appendSignal('-');
	          break;
	        case 'short_pause':
	          _this4.appendSignal('/');
	          break;
	        case 'out.symbol':
	          _this4.appendSymbol(event.data);
	          break;
	        default:
	          _this4.sc.gen(event);
	      }
	    };
	
	    if (options && options.delay) {
	      this.timeouts[event.sendid] = setTimeout(send, options.delay);
	    } else {
	      send();
	    }
	  };
	
	  MorseExample.prototype.customCancel = function customCancel(sendid) {
	    clearTimeout(this.timeouts[sendid]);
	    delete this.timeouts[sendid];
	  };
	
	  MorseExample.prototype.appendSignal = function appendSignal(signal) {
	    this.setState(function (_ref) {
	      var signals = _ref.signals;
	      return { signals: signals.concat(signal).slice(-24) };
	    });
	  };
	
	  MorseExample.prototype.appendSymbol = function appendSymbol(symbol) {
	    if (!symbol) return;
	    this.setState(function (_ref2) {
	      var transcript = _ref2.transcript;
	      return {
	        transcript: transcript + symbol,
	        signals: []
	      };
	    });
	  };
	
	  MorseExample.prototype.pulse = function pulse(duration) {
	    var _this5 = this;
	
	    if (!this.sc) return;
	    this.sc.gen('device.press');
	    setTimeout(function () {
	      return _this5.sc && _this5.sc.gen('device.release');
	    }, duration);
	  };
	
	  MorseExample.prototype.restart = function restart() {
	    var _this6 = this;
	
	    if (this.sc) this.sc.gen('input.restart');
	    Object.keys(this.timeouts).forEach(function (sendid) {
	      return _this6.customCancel(sendid);
	    });
	    this.setState({ transcript: '', signals: [] });
	  };
	
	  MorseExample.prototype.render = function render() {
	    var _this7 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '560px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '560px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _morse2.default,
	            disableAnimation: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'morse-example'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '560px', border: '1px solid #eee' } },
	          _react2.default.createElement(_morsePanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            transcript: this.state.transcript,
	            signals: this.state.signals,
	            onPress: function onPress() {
	              return _this7.sc && _this7.sc.gen('device.press');
	            },
	            onRelease: function onRelease() {
	              return _this7.sc && _this7.sc.gen('device.release');
	            },
	            onPulse: function onPulse(duration) {
	              return _this7.pulse(duration);
	            },
	            onRestart: function onRestart() {
	              return _this7.restart();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return MorseExample;
	}(_react2.default.Component);
	
	exports.default = MorseExample;

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MorsePanel = function MorsePanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      transcript = _ref.transcript,
	      signals = _ref.signals,
	      onPress = _ref.onPress,
	      onRelease = _ref.onRelease,
	      onPulse = _ref.onPulse,
	      onRestart = _ref.onRestart;
	
	  var states = configuration || [];
	  var isPressed = states.indexOf('pressed') > -1;
	  var buffer = datamodel && datamodel.buffer ? datamodel.buffer : '';
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f6f6f6' } },
	    _react2.default.createElement(
	      'div',
	      { style: { minHeight: '7rem', background: '#202124', color: '#f2f2f2', padding: '1rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { color: '#9aa0a6', textTransform: 'uppercase', letterSpacing: '0.08em' } },
	        'Decoded text'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontFamily: 'monospace', fontSize: '2rem', lineHeight: '2.5rem', wordBreak: 'break-word' } },
	        transcript || '\xA0'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Current code'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontFamily: 'monospace', fontSize: '1.75rem', minHeight: '2.5rem' } },
	        buffer || '\xA0'
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: isPressed ? 'btn btn-danger' : 'btn btn-primary',
	        style: { width: '100%', height: '4rem', marginBottom: '0.75rem', fontSize: '1.25rem' },
	        onMouseDown: onPress,
	        onMouseUp: onRelease,
	        onMouseLeave: isPressed ? onRelease : undefined,
	        onTouchStart: onPress,
	        onTouchEnd: onRelease
	      },
	      isPressed ? 'Release key' : 'Hold key'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', marginBottom: '0.75rem' } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: { flex: 1, marginRight: '0.5rem' }, onClick: function onClick() {
	            return onPulse(100);
	          } },
	        'Dot'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: { flex: 1 }, onClick: function onClick() {
	            return onPulse(420);
	          } },
	        'Dash'
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-light', style: { width: '100%', marginBottom: '1rem' }, onClick: onRestart },
	      'Restart'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Signals'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontFamily: 'monospace', minHeight: '4rem', color: '#555' } },
	        signals.join(' ') || '\xA0'
	      )
	    )
	  );
	};
	
	exports.default = MorsePanel;
	module.exports = exports['default'];

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       name=\"ScxmlMorse\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data expr=\"''\" id=\"buffer\"/>\n    <data expr=\"''\" id=\"symbol\"/>\n    <data id=\"codeReference\">{\n      \"-----\"  : \"0\",\n      \".----\"  : \"1\",\n      \"..---\"  : \"2\",\n      \"...--\"  : \"3\",\n      \"....-\"  : \"4\",\n      \".....\"  : \"5\",\n      \"-....\"  : \"6\",\n      \"--...\"  : \"7\",\n      \"---..\"  : \"8\",\n      \"----.\"  : \"9\",\n      \".-\"     : \"a\",\n      \"-...\"   : \"b\",\n      \"-.-.\"   : \"c\",\n      \"-..\"    : \"d\",\n      \".\"      : \"e\",\n      \"..-.\"   : \"f\",\n      \"--.\"    : \"g\",\n      \"....\"   : \"h\",\n      \"..\"     : \"i\",\n      \".---\"   : \"j\",\n      \"-.-\"    : \"k\",\n      \".-..\"   : \"l\",\n      \"--\"     : \"m\",\n      \"-.\"     : \"n\",\n      \"---\"    : \"o\",\n      \".--.\"   : \"p\",\n      \"--.-\"   : \"q\",\n      \".-.\"    : \"r\",\n      \"...\"    : \"s\",\n      \"-\"      : \"t\",\n      \"..-\"    : \"u\",\n      \"...-\"   : \"v\",\n      \".--\"    : \"w\",\n      \"-..-\"   : \"x\",\n      \"-.--\"   : \"y\",\n      \"--..\"   : \"z\",\n      \".-.-.-\" : \".\",\n      \"--..--\" : \",\",\n      \"..--..\" : \"?\",\n      \"-.-.--\" : \"!\",\n      \"-....-\" : \"-\",\n      \"-..-.\"  : \"/\",\n      \".--.-.\" : \"@\",\n      \"-.--.\"  : \"(\",\n      \"-.--.-\" : \")\"\n    }</data>\n  </datamodel>\n\n  <state id=\"event_processor\" initial=\"entry_point\">\n    <transition event=\"input.restart\" target=\"event_processor\"/>\n\n    <state id=\"entry_point\">\n      <onentry>\n        <assign expr=\"''\" location=\"buffer\"/>\n      </onentry>\n      <transition event=\"device.press\" target=\"pressed\"/>\n    </state>\n\n    <state id=\"released\" initial=\"initial\">\n      <transition event=\"device.press\" target=\"pressed\"/>\n      <state id=\"initial\">\n        <onentry>\n          <send delay=\"300ms\" event=\"short_pause_timeout\" id=\"short_pause_timeout\"/>\n        </onentry>\n        <onexit>\n          <cancel sendid=\"short_pause_timeout\"/>\n        </onexit>\n        <transition event=\"short_pause_timeout\" target=\"short_pause\"/>\n      </state>\n\n      <state id=\"short_pause\">\n        <onentry>\n          <send delay=\"700ms\" event=\"long_pause_timeout\" id=\"long_pause_timeout\"/>\n          <send event=\"short_pause\"/>\n        </onentry>\n        <onexit>\n          <cancel sendid=\"long_pause_timeout\"/>\n        </onexit>\n        <transition event=\"long_pause_timeout\" target=\"long_pause\"/>\n      </state>\n\n      <state id=\"long_pause\">\n        <onentry>\n          <script><![CDATA[\nsymbol = codeReference[buffer]\n\nwhile (symbol === undefined && buffer.length) {\n    buffer = buffer.slice(0, -1)\n    symbol = codeReference[buffer]\n}\n          ]]></script>\n          <send event=\"out.symbol\">\n            <content expr=\"symbol\"/>\n          </send>\n          <assign expr=\"''\" location=\"buffer\"/>\n        </onentry>\n      </state>\n    </state>\n\n    <state id=\"pressed\" initial=\"sending_dot\">\n      <state id=\"sending_dot\">\n        <onentry>\n          <send delay=\"300ms\" event=\"dash-timeout\" id=\"dash-timeout\"/>\n        </onentry>\n        <onexit>\n          <cancel sendid=\"dash-timeout\"/>\n        </onexit>\n        <transition event=\"dash-timeout\" target=\"sending_dash\"/>\n        <transition event=\"device.release\" target=\"released\">\n          <send event=\"dot\"/>\n          <assign expr=\"buffer + '.'\" location=\"buffer\"/>\n        </transition>\n      </state>\n\n      <state id=\"sending_dash\">\n        <transition event=\"device.release\" target=\"released\">\n          <send event=\"dash\"/>\n          <assign expr=\"buffer + '-'\" location=\"buffer\"/>\n        </transition>\n      </state>\n    </state>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _morseExample = __webpack_require__(393);
	
	var _morseExample2 = _interopRequireDefault(_morseExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Morse = function Morse(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports Alex Zhornyak\'s Qt SCXML Morse Code Trainer EcmaScript example. The SCXML statechart distinguishes dot, dash, short pause, and long pause timing, while the React panel provides a browser keyer and decoded transcript.'
	    ),
	    React.createElement(_morseExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'Hardware demo'
	    ),
	    React.createElement(
	      'div',
	      { style: { position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', background: '#111', marginBottom: '2rem' } },
	      React.createElement('iframe', {
	        title: 'Morse hardware demo',
	        src: 'https://www.youtube.com/embed/7S-blsAqt_U',
	        style: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 },
	        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
	        allowFullScreen: true
	      })
	    ),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _morseExample.morseScxml
	    )
	  );
	};
	
	var WrappedMorse = function WrappedMorse(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Morse, pathname: location.pathname });
	};
	
	exports.default = WrappedMorse;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-morse-js-f2c329e979c5878241b1.js